module.exports = __webpack_public_path__ + "static/media/badgeQuality.29db667d.png";